import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "header" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("선물하기")
const _hoisted_3 = {
  id: "content",
  class: "content"
}
const _hoisted_4 = { class: "event_wrap" }
const _hoisted_5 = { class: "evt_box" }
const _hoisted_6 = { class: "btn_area_wrap" }
const _hoisted_7 = { class: "btn_area" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_header_component = _resolveComponent("header-component")

  return (_openBlock(), _createBlock("div", {
    id: "wrap",
    class: ["wrap", {app_view: _ctx.isApp}]
  }, [
    _createVNode("div", _hoisted_1, [
      _createVNode(_component_header_component, null, {
        default: _withCtx(() => [
          _hoisted_2
        ]),
        _: 1
      })
    ]),
    _createVNode("div", _hoisted_3, [
      _createVNode("div", _hoisted_4, [
        _createVNode("div", _hoisted_5, [
          _createVNode("img", {
            src: _ctx.promotionDetailImageUrl,
            alt: ""
          }, null, 8, ["src"])
        ])
      ]),
      _createVNode("div", _hoisted_6, [
        _createVNode("div", _hoisted_7, [
          (_ctx.showButton)
            ? (_openBlock(), _createBlock("button", {
                key: 0,
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.moveToProductDetail())),
                type: "button",
                class: "btn btn_buy"
              }, "상품 상세 보기"))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ], 2))
}